<template>
    <b-navbar type="light" :class="['border-bottom border-color-gray-300 bg-white qesg-navbar', { collapsed: collapsedSidebar }]">
        <b-navbar-brand>
            <b-btn variant="light" @click="$emit('collapseSidebar')">
                <b-icon-chevron-bar-left  v-show="!collapsedSidebar" />
                <b-icon-chevron-bar-right v-show="collapsedSidebar" />
            </b-btn>
        </b-navbar-brand>
        <b-navbar-nav>
            <b-card v-if="!GET_ProjectList.length || !getActiveProject" no-body class="shadow-xs mr-3">
                <div
                    class="d-flex align-items-center rounded text-secondary"
                    >
                    <div v-if="!GET_ProjectList" class="py-2 px-3"
                         style="width: 420px"
                    >
                        <h6 class="font-weight-normal font-italic mb-0">
                            {{ $t('존재하지 않는 프로젝트 입니다.')}}
                        </h6>
                    </div>
                    <div v-else-if="!GET_ProjectList.length" class="py-2 px-3"
                         style="width: 420px"
                    >
                        <h6 class="font-weight-normal font-italic mb-0">
                            {{ $t('생성된 프로젝트가 없습니다.')}}
                        </h6>
                    </div>
                </div>
            </b-card>
            
            <div v-else
                class="d-flex align-items-center"
                >
                <div class="d-flex align-items-center rounded text-secondary">
                    <auto-complete-select ref="autoComplete"
                                         v-model="selectedProjectCodeId"
                                         :options="projectCodeOptions"
                                         style="width: 420px"
                                         :loading="isProjectLoaded"
                                         startExpanded
                                         option-value-key="id"
                                         :placeholder="$t('프로젝트를 선택해주세요.')"
                                         @click="onItemClick">

                    </auto-complete-select>
                </div>
            </div>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
            <b-nav-item>
                <!-- 1 : QESG, 29960 : HMCK_ADMIN -->
                <b-btn
                    variant="light"
                    class="border ml-2 d-flex align-items-center"
                    :title="$t('참여기업 엑셀 다운로드')"
                    :disabled="isParticipantDownloading"
                    @click="openDownloadExcelModal"
                    >
                    <span class="mr-2">{{ $t("참여기업 엑셀 다운로드") }}</span>
                    <b-icon-download v-show="!isParticipantDownloading" class="ml-0" />
                    <span v-show="isParticipantDownloading">
                        <b-spinner :label="$t('엑셀 다운로드 중')" class="ml-2" small />
                    </span>
                </b-btn>
            </b-nav-item>
            <b-nav-item>
                <dropdown-language dropdownVariant="secondary" />
            </b-nav-item>
            <b-nav-item link-classes="h-100">
                <b-button class="h-100"
                    size="sm"
                    variant="dark-border"
                    @click="logout"
                    >
                    {{ $t('로그아웃') }}
                </b-button>
            </b-nav-item>
        </b-navbar-nav>
        <contractor-excel-download-modal/>
    </b-navbar>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex';
// import dayjs from 'dayjs';
import {
    BIconChevronBarLeft, BIconChevronBarRight
} from 'bootstrap-vue';
import downloadFile from '@shared_mixins/downloadFile';
import DropdownLanguage from '@shared_components/utils/dropdown-language';
import AutoCompleteSelect from '@core_components/common/AutoCompleteSelect.vue';
import ContractorExcelDownloadModal
    from '@shared/components/contractor/components/ContractorExcelDownload/ContractorExcelDownloadModal.vue';
export default {
    name: 'contractor-navigation-bar',
    components: {
        AutoCompleteSelect,
        ContractorExcelDownloadModal,
        BIconChevronBarLeft,
        BIconChevronBarRight,
        DropdownLanguage
    },
    props: {
        isProjectLoaded: {
            required: true,
            type: Boolean
        },
        collapsedSidebar: {
            required: true,
            type: Boolean
        }
    },
    data () {
        return {
            isParticipantDownloading: false,
            selectedProjectCodeId: null,
        };
    },
    computed: {
        ...mapState(['user_id']),
        ...mapGetters('contractor', [ 'Get_Contractor', 'GET_ProjectList' ]),
        getActiveProject () {
            if (!this.GET_ProjectList) {
                return null;
            } else {
                let _active_project = this.GET_ProjectList.find(_project => _project.project_code === this.$route.query.projectid);
                if (_active_project) {
                    return _active_project;
                } else {
                    return null;
                }
            }
        },
        projectCodeOptions(){
            const mapOptions = {};
            this.GET_ProjectList.forEach((item,idx) => {
                if(mapOptions[item.period] == null) {
                    mapOptions[item.period] = [];
                }
                mapOptions[item.period].push({
                    value: item,
                    text: `${item.project_code} (${item.period_dis[this.$i18n.locale]})`,
                    id: idx
                });
            });
            const result  = Object.entries(mapOptions).reduce((acc, [key, value]) => {
                acc.push({
                    group: key,
                    items: value
                });
                return acc;
            }, []);
            result.sort((a,b) => b.group.localeCompare(a.group));
            
            return result;
        }
    },
    watch: {
        '$route.query.projectid' (_project_id) {
            this.SET_PROJECT(_project_id);
        },
        projectCodeOptions: {
            deep: true,
            handler(){
                const { projectid } = this.$route.query;
                if(projectid){
                    this.projectCodeOptions.forEach(group => {
                        const foundItem = group.items.find(item => item.value.project_code === projectid);
                        if (foundItem) {
                            this.selectedProjectCodeId = foundItem.id;
                        }
                    });
                }
            }
        }
    },
    mounted () {
        
    },
    beforeDestroy () {},
    methods: {
        ...mapMutations('contractor', ['SET_PROJECT', 'SET_CONTRACTOR_REQUEST_TIME']),
        async onItemClick(item){
            await this.$router.push({
                name: this.$route.name,
                params: {
                    requestsId: this.Get_Contractor.company_id,
                },
                query: {
                    projectid: item.value.project_code
                }
            });
            this.$refs.autoComplete.hideList();
            
        },
        async logout () {
            await this.$store.dispatch('contractor/LogoutContractor');
            this.$router.push({ name: 'Login' });
        },
        openDownloadExcelModal () {
            this.$bvModal.show('contractor-excel-download-modal');
        },
    }
};
</script>

<style lang="scss">
.dropdown-project-select-menu {
    max-height: 80vh;
    overflow-y: auto;
}

</style>
